import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

export const Text = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
  ${Typography.BODY_XS};
   margin-bottom: 10px;
`;

export const Text2 = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  text-align: center;
  ${Typography.BODY_XS}
`;